class BrushNode {
  constructor(x, y) {
    this.x = this.ox = x || 0.0;
    this.y = this.oy = y || 0.0;
    this.vx = 0.0;
    this.vy = 0.0;
  }
}
export { BrushNode };
